/* eslint-disable */
import { Card, CardContent, CardHeader, CardTitle } from '../../Components/ui/card'
import env from '../../env/env'
import { get } from '../../http/restservice'
import { useEffect, useState } from 'react'

import { MoveRight, Plus } from 'lucide-react'
import { Button } from '../../Components/ui/button'
import { Info, KeyboardArrowDown, KeyboardArrowUp, Refresh } from '@mui/icons-material'
import { toCurrency } from '../../utils/CurrencyUtil'
import { Link } from 'react-router-dom'
import { capitalizeWords, formatDate } from '../../utils/Util'
import NoBond from '../../assets/images/nodata.svg'
import basketRowIcon from '../../assets/SVGS/fabits-basket-row-icon.svg'
import { Popover, PopoverContent, PopoverTrigger } from '../../Components/ui/popover'
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../../Components/ui/tooltip'
import ApiErrorState from '../../Components/Errors/ApiErrorState'
import { AnimatedDisclosure } from '../../Components/ui/animated-disclosure'

const UserBasketOrderHistory = ({ clientCode }) => {
  const [orders, setOrders] = useState({})

  useEffect(() => {
    const fetchCustomerBasketOrderHistory = async () => {
      try {
        const response = await get(
          `${env.API_URL}adminservice/api/actionPlan/fetchCustomerBasketOrderHistory?clientCode=${clientCode}`,
        )
        let data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data

        // let allotedAmount = data?.orders?.reduce((acc, order) => {
        //   return acc + (order?.allotedAmt ? Number(order.allotedAmt) : 0)
        // }, 0)

        setOrders(data)
      } catch (error) {
        console.log(error)
      }
    }

    fetchCustomerBasketOrderHistory()
  }, [])

  const [groupedOrders, setGroupedOrders] = useState({})
  const [expandedIndex, setExpandedIndex] = useState(null)
  const [expandedOrderKey, setExpandedOrderKey] = useState(null)

  const groupByBasketId = (orders) =>
    orders.reduce((acc, { customerBasketInvestmentId, basketStatus, ...order }) => {
      if (!acc[customerBasketInvestmentId]) {
        acc[customerBasketInvestmentId] = []
      }
      acc[customerBasketInvestmentId].push({ basketStatus, ...order })
      return acc
    }, {})

  useEffect(() => {
    if (orders?.orders?.length > 0) {
      setGroupedOrders(groupByBasketId(orders.orders))
    } else if (orders.state === 'hasError') {
      console.error('Error fetching orders:', orders)
    }
  }, [orders])

  const getTotalUnits = (basketOrders) => {
    return basketOrders.reduce((acc, order) => {
      return acc + Number(order.allotedUnits ? order.allotedUnits : 0)
    }, 0)
  }

  const getTotalAmount = (basketOrders) => {
    return basketOrders.reduce((acc, order) => {
      return acc + Number(order.allotedAmt ? order.allotedAmt : 0)
    }, 0)
  }

  const getStatus = (currentStatus) => {
    const statusMapping = {
      allotment: 'Allotted',
      partial: 'Partial',
      failed: 'Failed',
      processed: 'In Progress',
      placed: 'In Progress',
    }

    // Convert currentStatus to lowercase for case-insensitive matching
    const lowerCaseStatus = currentStatus.toLowerCase()

    // Iterate over the keys in statusMapping
    for (const keyword in statusMapping) {
      if (lowerCaseStatus.includes(keyword)) {
        return statusMapping[keyword]
      }
    }

    // Default return value if no keywords are matched
    return 'Unknown Status'
  }

  return (
    <div className='bg-white min-h-screen py-6'>
      {orders?.status === 'SUCCESS' && orders?.orders?.length > 0 && (
        <>
          <div className='max-w-[1020px] mx-auto overflow-hidden'>
            {orders?.orders?.length > 0 ? (
              Object.entries(groupedOrders).map(([key, basketOrders], index) => {
                let sortedOrders = [...basketOrders].sort(
                  (a, b) => b.customerBasketOrderNo - a.customerBasketOrderNo,
                )
                const orderTotals = sortedOrders.reduce((acc, item) => {
                  const orderNo = item.customerBasketOrderNo
                  if (!acc[orderNo]) {
                    acc[orderNo] = 0
                  }
                  acc[orderNo] += Number(item?.allotedAmt ? item.allotedAmt : 0)
                  return acc
                }, {})
                const orderStatusMap = sortedOrders.reduce((acc, item) => {
                  const orderNo = item.customerBasketOrderNo
                  if (!acc[orderNo]) {
                    acc[orderNo] = []
                  }
                  acc[orderNo].push(getStatus(item.currentStatus))
                  return acc
                }, {})

                return (
                  <div key={key} className='cursor-pointer w-full'>
                    <div className='py-2 text-sm font-medium text-black-400 mb-4 mt-12 leading-5 px-4 lg:px-0'>
                      <div
                        className='flex justify-between items-center w-full'
                        onClick={() => {
                          setExpandedIndex((prev) => (prev === index ? null : index))
                        }}
                      >
                        <div className='w-full md:w-auto'>
                          <div className='flex md:justify-between items-start md:items-center gap-x-2'>
                            <img
                              src={basketRowIcon}
                              className='fabits-basket-row-icon'
                              alt=''
                              aria-hidden='true'
                            />

                            <div className='w-full'>
                              <div className='flex justify-between gap-x-4 items-center'>
                                <p className='font-semibold text-gray-900  md:max-w-full text-wrap leading-6'>
                                  {basketOrders[0]?.customerBasketName}
                                </p>

                                {basketOrders[0]?.buySell && (
                                  <p
                                    className={`hidden md:block text-sm leading-4 px-3 py-1 rounded-full ${basketOrders[0]?.buySell === 'P'
                                        ? 'bg-secondary-50 text-secondary-600'
                                        : 'bg-error-50 text-error-600'
                                      }`}
                                  >
                                    {basketOrders[0]?.buySell === 'P' ? 'Buy' : 'Sell'}
                                  </p>
                                )}

                                <span className='flex-shrink-0 text-black-200 md:hidden'>
                                  {expandedIndex === index ? (
                                    <KeyboardArrowUp
                                      className='flex-shrink-0 text-black-200'
                                      sx={{ fontSize: '24px' }}
                                    />
                                  ) : (
                                    <KeyboardArrowDown
                                      className='flex-shrink-0 text-black-200'
                                      sx={{ fontSize: '24px' }}
                                    />
                                  )}
                                </span>
                              </div>

                              <div className='flex justify-between md:justify-normal gap-x-5'>
                                <p
                                  className={`text-sm font-medium ${basketOrders[0]?.basketStatus.toLowerCase() === 'completed'
                                      ? 'text-secondary-600'
                                      : basketOrders[0]?.basketStatus.toLowerCase() ===
                                        'in progress'
                                        ? 'text-warning-600'
                                        : 'text-error-600'
                                    }`}
                                >
                                  {capitalizeWords(basketOrders[0]?.basketStatus)}
                                </p>

                                {basketOrders[0]?.buySell && (
                                  <p
                                    className={`md:hidden text-sm leading-4 px-3 py-1 rounded-full ${basketOrders[0]?.buySell === 'P'
                                        ? 'bg-secondary-50 text-secondary-600'
                                        : 'bg-error-50 text-error-600'
                                      }`}
                                  >
                                    {basketOrders[0]?.buySell === 'P' ? 'Buy' : 'Sell'}
                                  </p>
                                )}
                              </div>

                              {/* {basketOrders[0]?.basketStatus.toLowerCase() != 'failed' && (
                                <div className='flex justify-between mt-1 md:hidden'>
                                  {basketOrders[0]?.basketStatus.toLowerCase() === 'completed' ? (
                                    <p className='text-sm font-medium text-black-400'>
                                      {toCurrency(getTotalUnits(basketOrders))} Units
                                    </p>
                                  ) : (
                                    <>
                                      <Popover>
                                        <PopoverTrigger
                                          className='text-black-400'
                                          onClick={(e) => e.stopPropagation()} // Prevent parent click
                                        >
                                          In progress{' '}
                                          <Info fontSize='10px' className='text-black-100' />
                                        </PopoverTrigger>
                                        <PopoverContent className='bg-black-500 text-center'>
                                          <p className='text-white'>
                                            Investments could take up to 4 days to reflect in your
                                            account
                                          </p>
                                        </PopoverContent>
                                      </Popover>
                                    </>
                                  )}

                                  {basketOrders[0]?.basketStatus.toLowerCase() === 'completed' ? (
                                    <p className='text-sm font-semibold text-black-500'>
                                      ₹ {toCurrency(getTotalAmount(basketOrders))}
                                    </p>
                                  ) : (
                                    <Popover>
                                      <PopoverTrigger
                                        className='text-black-400'
                                        onClick={(e) => e.stopPropagation()} // Prevent parent click
                                      >
                                        In progress{' '}
                                        <Info fontSize='10px' className='text-black-100' />
                                      </PopoverTrigger>
                                      <PopoverContent className='bg-black-500 text-center'>
                                        <p className='text-white'>
                                          Investments could take up to 4 days to reflect in your
                                          account
                                        </p>
                                      </PopoverContent>
                                    </Popover>
                                  )}
                                </div>
                              )} */}
                            </div>
                          </div>
                        </div>

                        <div className='flex items-center gap-x-4'>
                          {/* {
                            <div className='hidden md:flex leading-5 flex-shrink-0 text-right w-[100px]'>
                              {basketOrders[0]?.basketStatus.toLowerCase() === 'completed' ? (
                                <p className='text-sm font-medium text-black-400'>
                                  {toCurrency(getTotalUnits(basketOrders))} Units
                                </p>
                              ) : (
                                <>
                                  {' '}
                                  {basketOrders[0]?.basketStatus.toLowerCase() != 'failed' && (
                                    <TooltipProvider delayDuration={0}>
                                      <Tooltip>
                                        <TooltipTrigger className='text-black-400'>
                                          In progress{' '}
                                          <Info fontSize='10px' className='text-black-100' />
                                        </TooltipTrigger>
                                        <TooltipContent className='bg-black-500 max-w-[275px] border-0'>
                                          <p className='text-white'>
                                            Investments could take up to 4 days to reflect in your
                                            account
                                          </p>
                                          <TooltipArrow />
                                        </TooltipContent>
                                      </Tooltip>
                                    </TooltipProvider>
                                  )}
                                </>
                              )}
                            </div>
                          } */}

                          <div className='hidden md:flex justify-end items-center gap-x-1 min-w-[150px]'>
                            {basketOrders[0]?.basketStatus.toLowerCase() === 'completed' ? (
                              <p className='font-semibold leading-6 text-black-500'>
                                ₹ {toCurrency(getTotalAmount(basketOrders))}
                              </p>
                            ) : (
                              <>
                                {basketOrders[0]?.basketStatus.toLowerCase() != 'failed' && (
                                  <TooltipProvider delayDuration={0}>
                                    <Tooltip>
                                      <TooltipTrigger className='text-black-400'>
                                        In progress{' '}
                                        <Info fontSize='10px' className='text-black-100' />
                                      </TooltipTrigger>
                                      <TooltipContent className='bg-black-500 max-w-[275px] border-0'>
                                        <p className='text-white'>
                                          Investments could take up to 4 days to reflect in your
                                          account
                                        </p>
                                        <TooltipArrow />
                                      </TooltipContent>
                                    </Tooltip>
                                  </TooltipProvider>
                                )}
                              </>
                            )}

                            {expandedIndex === index ? (
                              <KeyboardArrowUp
                                className='flex-shrink-0 text-black-200'
                                sx={{ fontSize: '24px' }}
                              />
                            ) : (
                              <KeyboardArrowDown
                                className='flex-shrink-0 text-black-200'
                                sx={{ fontSize: '24px' }}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                      <AnimatedDisclosure
                        open={expandedIndex === index}
                        className='text-sm md:pl-6 flex-col justify-between items-start mt-4 border-b text-gray-500'
                        contentClassName='pt-4'
                      >
                        {sortedOrders?.map((order, index) => {
                          const isFirstOrderRow =
                            index === 0 ||
                            order.customerBasketOrderNo !==
                            sortedOrders[index - 1].customerBasketOrderNo
                          const currentOrderKey = `${key}-${order.customerBasketOrderNo}`
                          const isOrderExpanded = expandedOrderKey === currentOrderKey
                          const currentOrderStatuses =
                            orderStatusMap[order.customerBasketOrderNo] || []
                          const orderLevelStatus =
                            currentOrderStatuses.length > 0 &&
                              currentOrderStatuses.every((status) => status === 'Allotted')
                              ? 'Allotted'
                              : currentOrderStatuses.length > 0 &&
                                currentOrderStatuses.every((status) => status === 'Failed')
                                ? 'Failed'
                                : 'Partial'

                          if (!isFirstOrderRow && !isOrderExpanded) {
                            return null
                          }

                          return (
                            <div className='py-2 w-full' key={index}>
                              <div className='flex justify-between w-full'>
                                <div className='flex justify-between items-start w-full min-w-0 gap-x-3'>
                                  <div className='w-full'>
                                    {isFirstOrderRow && (
                                      <div
                                        className='w-full flex justify-between items-center gap-x-2 text-black-400 text-sm cursor-pointer py-1'
                                        onClick={() => {
                                          setExpandedOrderKey((prev) =>
                                            prev === currentOrderKey ? null : currentOrderKey,
                                          )
                                        }}
                                      >
                                        <div className='flex items-center justify-evenly gap-x-3 w-full'>
                                          <span className='flex-1'>
                                            Order #{order.customerBasketOrderNo}
                                          </span>

                                          <div className='flex-1 text-left'>
                                            <span
                                              className={`text-xs leading-4 px-2 py-0.5 rounded-full ${orderLevelStatus === 'Allotted'
                                                  ? 'bg-secondary-50 text-secondary-600'
                                                  : orderLevelStatus === 'Failed'
                                                    ? 'bg-error-50 text-error-600'
                                                    : 'bg-warning-50 text-warning-600'
                                                }`}
                                            >
                                              {orderLevelStatus}
                                            </span>
                                          </div>

                                          <span className=' text-black-500 font-semibold'>
                                            ₹ {toCurrency(orderTotals[order.customerBasketOrderNo])}
                                          </span>
                                        </div>

                                        <div className='flex items-center justify-end gap-x-2 min-w-[140px] flex-shrink-0'>
                                          <span className='inline-block w-[100px] text-right'>
                                            {formatDate(order.createdDate)}
                                          </span>
                                          {isOrderExpanded ? (
                                            <KeyboardArrowUp
                                              className='flex-shrink-0 text-black-200'
                                              sx={{ fontSize: '20px' }}
                                            />
                                          ) : (
                                            <KeyboardArrowDown
                                              className='flex-shrink-0 text-black-200'
                                              sx={{ fontSize: '20px' }}
                                            />
                                          )}
                                        </div>
                                      </div>
                                    )}

                                    <AnimatedDisclosure
                                      open={isOrderExpanded}
                                      contentClassName='pt-2'
                                    >
                                      <div className='flex items-start md:items-center justify-between gap-x-3 w-full'>
                                        <div className='flex items-start gap-x-2 flex-1 min-w-0'>
                                          <img
                                            src={`${env.MF_LOGOS_URL}/${order?.amcCode}.png`}
                                            className='h-12 w-12 rounded-[8px] mt-1 flex-shrink-0'
                                          />
                                          <div className='flex-1 min-w-0'>
                                            <p className='font-semibold text-gray-900 leading-6 break-words'>
                                              {order?.legalName
                                                ? order?.legalName
                                                : order?.schemeName}
                                            </p>

                                            <div className='flex justify-between md:justify-normal w-full gap-x-5'>
                                              <p
                                                className={`text-sm font-medium ${getStatus(order.currentStatus) === 'Failed'
                                                    ? 'text-error-600'
                                                    : getStatus(order.currentStatus) === 'Allotted'
                                                      ? 'text-secondary-600'
                                                      : 'text-warning-600'
                                                  }`}
                                              >
                                                {getStatus(order.currentStatus)}
                                              </p>

                                              <p className='hidden md:block text-sm text-black-400 leading-5 font-medium'>
                                                Order ID : {order?.orderNumber}
                                              </p>

                                              {order?.buySell && (
                                                <p
                                                  className={`md:hidden text-sm leading-4 px-3 py-1 rounded-full ${order?.buySell === 'P'
                                                      ? 'bg-secondary-50 text-secondary-600'
                                                      : 'bg-error-50 text-error-600'
                                                    }`}
                                                >
                                                  {order?.buySell === 'P' ? 'Buy' : 'Sell'}
                                                </p>
                                              )}
                                            </div>
                                          </div>
                                          <div className='flex flex-col items-end justify-end gap-x-2'>
                                            {order.allotedUnits && (
                                              <p className='text-sm font-medium text-black-400'>
                                                {order.allotedUnits
                                                  ? toCurrency(order.allotedUnits)
                                                  : null}{' '}
                                                Units
                                              </p>
                                            )}

                                            {order.allotedAmt && (
                                              <p className='font-semibold leading-6 text-black-500'>
                                                ₹{' '}
                                                {order.allotedAmt
                                                  ? toCurrency(order.allotedAmt)
                                                  : null}
                                              </p>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </AnimatedDisclosure>
                                  </div>

                                  {/* <div
                                    className={`overflow-hidden transition-all duration-300 ease-in-out ${isOrderExpanded
                                      ? 'max-h-[120px] opacity-100 translate-y-0 pt-2'
                                      : 'max-h-0 opacity-0 -translate-y-1'
                                      }`}
                                  >
                                    <div className='hidden md:flex items-center gap-x-2 flex-shrink-0'>
                                      <div className='flex justify-end leading-5 text-right w-[90px]'>
                                        {order.allotedUnits && (
                                          <p className='text-sm font-medium text-black-400 whitespace-nowrap'>
                                            {order.allotedUnits
                                              ? toCurrency(order.allotedUnits)
                                              : null}{' '}
                                            Units
                                          </p>
                                        )}
                                      </div>

                                      <div className='flex justify-end items-center w-[130px] pr-2'>
                                        {order.allotedAmt && (
                                          <p className='font-semibold leading-6 text-black-500 whitespace-nowrap'>
                                            ₹ {order.allotedAmt ? toCurrency(order.allotedAmt) : null}
                                          </p>
                                        )}
                                      </div>
                                    </div>
                                  </div> */}
                                </div>
                              </div>
                            </div>
                          )
                        })}
                      </AnimatedDisclosure>
                    </div>
                  </div>
                )
              })
            ) : (
              <Boilerplate
                state={'You have no orders in progress at the moment.'}
                desc={
                  'It seems like you haven’t started any new orders yet. Once you place an order, it will appear here as it progresses through the system.'
                }
              />
            )}
          </div>
        </>
      )}

      {orders?.length === 0 && (
        <div className='bg-white flex items-center justify-center'>
          <Card className='w-full max-w-2xl text-center border-none shadow-none'>
            <CardHeader className='flex flex-col justify-center items-center space-y-2'>
              <img src={NoBond} width={400} alt='No Bond' />
              <CardTitle className='text-xl'>You haven’t set any goals yet</CardTitle>
            </CardHeader>
            <CardContent>
              <p className='text-muted-foreground mb-6'>
                Take the first step towards your financial future by setting up a goal today.
              </p>
              <Link to='/dashboard/plans'>
                <Button className='w-full'>
                  <Plus className='mr-2 h-4 w-4' /> Create Goal
                </Button>
              </Link>
            </CardContent>
          </Card>
        </div>
      )}

      {orders?.status === 'FAILURE' && (
        <div className='bg-white flex items-center justify-center'>
          <ApiErrorState>
            <div className='fabits-api-error-actions'>
              <Button
                className='w-full'
                variant='fabitsWhite'
                onClick={() => window.location.reload()}
              >
                <Refresh className='mr-2 h-4 w-4 text-black-300' /> Refresh
              </Button>

              <Link className='flex-1' to='/dashboard/mutual-funds'>
                <Button className='w-full'>
                  View Funds
                  <MoveRight className='ml-2 h-4 w-4' />
                </Button>
              </Link>
            </div>
          </ApiErrorState>
        </div>
      )}
    </div>
  )
}

export const Boilerplate = ({ state, desc }) => {
  return (
    <div className='h-3/5 flex items-center justify-center p-4'>
      <Card className='w-full max-w-sm text-center border-none shadow-none'>
        <CardHeader>
          <div className='w-20 h-20 mx-auto mb-4 flex justify-center items-center'>
            <img src={`${env.SVGS}/error-icon.svg`} />
          </div>
          <CardTitle className='text-xl'>{state}</CardTitle>
        </CardHeader>
        <CardContent>
          <p className='text-muted-foreground mb-6'>{desc}</p>
        </CardContent>
      </Card>
    </div>
  )
}

export default UserBasketOrderHistory
